/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-01.png'
import Gmoney from '@assets/images/guide/g-money.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { GuideWrap, GuideImgWrap } from '../index.style'

const AchieveGoalPopup: React.FC = props => {
  const { globalStore } = useRootStore()
  const { visibleAchieveGoalPopup } = globalStore

  const onCloseModal = async () => {
    globalStore.setVisibleAchieveGoalPopup(false)
  }

  const reward = globalStore.getFirstBetMoneyReward().toLocaleString()

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleAchieveGoalPopup}
        maskClosable={false}
        onClose={onCloseModal}
        className="adv-new-dialog box-type big-size character-popup"
        wrapClassName="guide-notice-popup"
        css={AdvDialogStyle}
      >
        {/* 캐릭터 영역 */}
        <GuideImgWrap>
          <div className="guide-circle">
            <img src={GuideCharacter} alt="캐릭터" className="guide-character"/>
          </div>
          <p className="guide-txt">
            목표 달성 축하 드립니다!
            <br/>
            메세지 함을 확인해주세요.
          </p>
        </GuideImgWrap>

        <GuideWrap>
          <div className="guide-box reward-img">
            <img src={Gmoney} alt="포인트"/>
          </div>

          <div className="guide-box reward no-bg">보상: <span className="point-color--orange--modal">{reward}</span><GmoneyIco/></div>
        </GuideWrap>

        <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} className="single-btn">
            확인
          </Button>
        </AdvDialogBtnWrap>

        <ModalBg onClick={onCloseModal}/>

      </Modal>
    </Fragment>
  )
}

export default observer(AchieveGoalPopup)
